import React from 'react';
import { Box, FormControlLabel, Checkbox } from '@mui/material';
import { BlockFormState } from '../../types';

interface PermissionsTabProps {
    kedo: any;
    state: BlockFormState;
    onChangeRole: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const PermissionsTab: React.FC<PermissionsTabProps> = ({
    kedo,
    state,
    onChangeRole,
}) => {
    return (
        <Box>
            {state.availableRoles.map((item: any) => (
                <FormControlLabel
                    key={item.id}
                    control={
                        <Checkbox
                            value={item.id}
                            checked={state.item.roles.includes(item.id)}
                            onChange={onChangeRole}
                        />
                    }
                    label={item.name}
                />
            ))}
        </Box>
    );
};

export default PermissionsTab;